<template lang="pug">
div.checkout-page.expande-horizontal.wrap
  checkout-header
  div.expande-horizontal.centraliza.wrap.pa-3
    v-flex.checkout-shell(xs12 md11 lg10)
      div.expande-horizontal.wrap
        v-flex(xs12 md4).pa-2
          checkout-items
        v-flex(xs12 md8).pa-2
          div.checkout-content-card.expande-horizontal.wrap.pa-5
            checkout-informations
            checkout-payment-method
            checkout-submit
  modal-order-status
</template>

<script>
import CheckoutHeader from "./CheckoutHeader.vue";
import CheckoutItems from "./CheckoutItems/index.vue";
import CheckoutInformations from "./CheckoutInformations/index.vue";
import CheckoutPaymentMethod from "./CheckoutPaymentMethod/index.vue";
import CheckoutSubmit from "./CheckoutSubmit/index.vue";
import ModalOrderStatus from "./ModalOrderStatus/index.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["plan_slug"],
  components: {
    CheckoutHeader,
    CheckoutItems,
    CheckoutInformations,
    CheckoutPaymentMethod,
    CheckoutSubmit,
    ModalOrderStatus
  },
  computed: {
    ...mapGetters(["get_checkout"])
  },
  methods: {
    ...mapActions(["view_plan", "check_transaction_payment"])
  },
  mounted() {
    if (this.plan_slug) {
      this.view_plan({
        plan_slug: this.plan_slug,
        trial: false
      });
    }
    if (this.$route.query.t_id) {
      this.check_transaction_payment(this.$route.query.t_id);
    }
  }
};
</script>

<style scoped>
.checkout-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #f5f7ff 0%, #eef2f9 100%);
}

.checkout-shell {
  max-width: 1200px;
}

.checkout-content-card {
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e9ecf5;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
}
</style>
